import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = { key: 0 };
import { computed, ref, toRefs, withModifiers, } from 'vue';
import { i18n } from '@/locales';
import registeredAreaListTableHeader from '@/constants/areaControl';
import createDeliveryChargeAreaControlFormRules from '@/form/form-rules/deliveryChargeAreaControl';
import { setLimitedByteText } from '@/utils';
import { validationLimitingValue } from '@/constants';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import vuexStore from '@/vuex-store';
const lc = 'views.delivery_charge_area_control.registered_area.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RegisteredAreaListTable',
    props: {
        isFetching: { type: Boolean, default: false },
        isError: { type: Boolean, default: false },
        handleGetRequestProcess: { type: Function, default: () => { } }
    },
    setup(__props) {
        // 구역 설정 > 구역 리스트
        const props = __props;
        const { isFetching, isError, handleGetRequestProcess, } = toRefs(props);
        const getterIsCreateAreaMode = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterIsCreateAreaMode']);
        const getterRegisteredAreaList = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterRegisteredAreaList']);
        const getterCheckedAreaList2 = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterCheckedAreaList2']);
        const getterAreaNameSearchValue = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterAreaNameSearchValue']);
        const localeInfo = computed(() => {
            const temp = {
                areaName: {
                    placeholder: i18n.t('common.input_field_placeholder', {
                        field: i18n.t(`${lc}area_name`),
                    }),
                },
                noDataText: i18n.t(`${lc}no_data_text`),
            };
            if (isFetching.value) {
                temp.noDataText = i18n.t('common.on_fetching');
            }
            if (isError.value) {
                temp.noDataText = i18n.t('common.data_can_not_load');
            }
            if (getterAreaNameSearchValue.value) {
                temp.noDataText = i18n.t('common.no_data_text');
            }
            return temp;
        });
        const formRules = createDeliveryChargeAreaControlFormRules('form_rules.');
        const currentEditAreaName = ref('');
        const currentEditAreaNameRef = ref(null);
        const { DELIVERY_CHARGE_AREA_NAME_MAX_LENGTH } = validationLimitingValue;
        const isEditAreaNameMode = ref(false);
        const currentEditAreaId = ref(0);
        const resetCurrentEditAreaInfo = () => {
            currentEditAreaName.value = '';
            currentEditAreaId.value = 0;
        };
        const isEditRow = (areaId) => isEditAreaNameMode.value && areaId === currentEditAreaId.value;
        const handleChangeCurrentEditAreaName = ({ target }) => {
            const { value } = target;
            currentEditAreaName.value = setLimitedByteText(value, DELIVERY_CHARGE_AREA_NAME_MAX_LENGTH, currentEditAreaNameRef.value);
        };
        const handleClickCancel = () => {
            resetCurrentEditAreaInfo();
            isEditAreaNameMode.value = false;
        };
        /**
         * 구역명 삭제 클릭 핸들러
         * @param areaId
         */
        const handleClickDeleteArea = async (areaId) => {
            handleClickCancel();
            const isConfirmOk = await vuexStore.dispatch(alertActionType.confirm, {
                headerTitle: i18n.t(`${lc}delete_area`),
                bodyContent: i18n.t(`${lc}confirm_before_delete_area`),
                btnConfig: [
                    {
                        text: 'cancel',
                        cssClass: 'outlined info',
                    },
                    {
                        text: 'ok',
                        cssClass: 'danger',
                    },
                ],
            });
            if (!isConfirmOk) {
                return;
            }
            const response = await vuexStore.dispatch('deliveryChargeAreaControl/deleteClickedArea', areaId);
            if (response.isSuccess) {
                handleGetRequestProcess.value();
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t(`${lc}delivery_charge_area_config_complete.delete`),
                });
                vuexStore.dispatch('deliveryChargeAreaControl/setCurrentPolygonNeedResetList', [
                    String(areaId),
                ]);
                const isDelete = true;
                vuexStore.dispatch('deliveryChargeAreaControl/setCheckedListAreaInfo', {
                    isDelete,
                    areaId,
                });
                vuexStore.dispatch('deliveryChargeAreaControl/setCheckedAreaList2DeleteById', areaId);
            }
            else {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: response.message,
                });
            }
        };
        /**
         * 구역명 수정 핸들러
         */
        const handleClickEditArea = (areaId, areaName) => {
            resetCurrentEditAreaInfo();
            isEditAreaNameMode.value = true;
            currentEditAreaId.value = areaId;
            currentEditAreaName.value = areaName;
        };
        /**
         * 구역명 수정 완료 클릭 핸들러
         * @param areaId
         * @param areaName
         */
        const handleClickEditDone = async (areaId, areaName) => {
            const isValid = currentEditAreaNameRef.value.validate();
            if (!isValid) {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.form_validation_error'),
                });
                return;
            }
            if (areaName === currentEditAreaName.value) {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t(`${lc}not_valid_area_name_error`),
                });
                return;
            }
            const response = await vuexStore.dispatch('deliveryChargeAreaControl/editClickedAreaName', {
                areaId,
                areaName: currentEditAreaName.value,
            });
            resetCurrentEditAreaInfo();
            isEditAreaNameMode.value = false;
            if (response.isSuccess) {
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t(`${lc}delivery_charge_area_config_complete.edit`),
                });
            }
            else {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: response.message,
                });
            }
            handleGetRequestProcess.value();
        };
        /**
         * model update 핸들러
         * @param checkedList
         */
        const handleUpdateModelValue = (checkedList) => {
            vuexStore.dispatch('deliveryChargeAreaControl/setCheckedAreaList2', checkedList);
        };
        return (_ctx, _cache) => {
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_data_table_virtual = _resolveComponent("v-data-table-virtual");
            return (_openBlock(), _createBlock(_component_v_data_table_virtual, {
                "model-value": getterCheckedAreaList2.value,
                hover: "",
                class: "registered-area-list-table brg-table brg-checkbox-table",
                "hide-default-footer": "",
                "fixed-header": "",
                "show-select": "",
                "item-value": "areaId",
                "no-data-text": localeInfo.value.noDataText,
                items: getterRegisteredAreaList.value,
                headers: _unref(registeredAreaListTableHeader),
                "items-per-page": -1,
                density: "compact",
                "item-height": "41",
                "onUpdate:modelValue": handleUpdateModelValue
            }, {
                [`header.data-table-select`]: _withCtx(({ someSelected, allSelected, selectAll }) => [
                    _createVNode(_component_v_checkbox, {
                        "model-value": allSelected,
                        indeterminate: someSelected && !allSelected,
                        density: "compact",
                        disabled: getterIsCreateAreaMode.value,
                        "hide-details": "",
                        "onUpdate:modelValue": (value) => selectAll(value)
                    }, null, 8 /* PROPS */, ["model-value", "indeterminate", "disabled", "onUpdate:modelValue"])
                ]),
                [`item.data-table-select`]: _withCtx(({ isSelected, toggleSelect, internalItem }) => [
                    _createVNode(_component_v_checkbox, {
                        "model-value": isSelected([internalItem]),
                        density: "compact",
                        "hide-details": "",
                        disabled: getterIsCreateAreaMode.value,
                        onclick: withModifiers(() => toggleSelect(internalItem), ['stop'])
                    }, null, 8 /* PROPS */, ["model-value", "disabled", "onclick"])
                ]),
                [`item.areaName`]: _withCtx(({ item }) => [
                    (isEditRow(item.areaId))
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 0,
                            ref_key: "currentEditAreaNameRef",
                            ref: currentEditAreaNameRef,
                            modelValue: currentEditAreaName.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentEditAreaName).value = $event)),
                            density: "compact",
                            variant: "outlined",
                            "hide-details": "auto",
                            "validate-on-blur": "",
                            oninput: "javascript: this.value = this.value.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9]/g, '');",
                            placeholder: localeInfo.value.areaName.placeholder,
                            rules: _unref(formRules).currentAreaName.value,
                            onInput: handleChangeCurrentEditAreaName
                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules"]))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            title: item.areaName
                        }, _toDisplayString(item.areaName), 9 /* TEXT, PROPS */, _hoisted_1))
                ]),
                [`item.areaConfig`]: _withCtx(({ item: { areaId, areaName } }) => [
                    _createCommentVNode(" 수정일 경우 "),
                    (isEditRow(areaId))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_v_btn, {
                                density: "comfortable",
                                icon: "mdi-check",
                                color: "blue",
                                variant: "text",
                                class: "mr-1",
                                onClick: ($event) => (handleClickEditDone(areaId, areaName))
                            }, null, 8 /* PROPS */, ["onClick"]),
                            _createVNode(_component_v_btn, {
                                icon: "mdi-close",
                                density: "comfortable",
                                color: "black",
                                variant: "text",
                                onClick: handleClickCancel
                            })
                        ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode(" 기본 상태 "),
                            _createElementVNode("div", null, [
                                _createVNode(_component_v_btn, {
                                    density: "comfortable",
                                    icon: "mdi-pencil-outline",
                                    color: "black",
                                    variant: "text",
                                    class: "mr-1",
                                    disabled: getterIsCreateAreaMode.value,
                                    onClick: ($event) => (handleClickEditArea(areaId, areaName))
                                }, null, 8 /* PROPS */, ["disabled", "onClick"]),
                                _createVNode(_component_v_btn, {
                                    density: "comfortable",
                                    color: "black",
                                    variant: "text",
                                    icon: "mdi-trash-can-outline",
                                    disabled: getterIsCreateAreaMode.value,
                                    onClick: ($event) => (handleClickDeleteArea(areaId))
                                }, null, 8 /* PROPS */, ["disabled", "onClick"])
                            ])
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                ]),
                bottom: _withCtx(() => _cache[1] || (_cache[1] = [])),
                _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "no-data-text", "items", "headers"]));
        };
    }
});
